var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ManagePagesHeader'),_c('v-content',[_c('v-layout',{attrs:{"justify-center":"","wrap":"","mt-3":""}},[_c('v-flex',{staticClass:"manage-pages-content",attrs:{"xs12":"","sm8":"","md7":"","lg6":"","xl4":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }